// import css from './catalog.module.css'

// export default function DiscountAndAction() {

//     return(
//         <div className={css.discountAndACWrapp}>
// <div className={css.discountAndACWrappFirst}>
// <div className={css.freeDelyvery}>
// Безкоштовна доставка від 1000 грн
// </div>
// <div className={css.procentSale}>
// 10% знижки від 700 грн
// </div>
// </div>
// <div className={css.discountAndACWrappSecond}>
// <div className={css.discountForNine}>15% знижки від 990 грн</div>
// <div className={css.krohmalPackeg}>Фірмовий крохмаль пакет у подарунок</div>
// <div className={css.smakolukForUser}>Смаколики для спільноти</div>

// </div>
//         </div>
//     )
// }

import { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../firebase"; // підкоригуй шлях до свого файлу
import css from "./catalog.module.css";

const DOC_ID = "discountAndAction";

export default function DiscountAndActionDynamic() {
  const [data, setData] = useState(null);

  useEffect(() => {
    const run = async () => {
      try {
        const ref = doc(db, "mainPage", DOC_ID);
        const snap = await getDoc(ref);
        if (snap.exists()) {
          setData(snap.data());
        } else {
          // Якщо документа ще нема — нічого не ламаємо, просто сховаємо блок
          setData(null);
        }
      } catch (e) {
        console.error("Помилка читання Firestore:", e);
        setData(null);
      }
    };
    run();
  }, []);

  if (!data) return null; // або показати прелоадер/заглушку

  return (
    <div className={css.discountAndACWrapp}>
      <div className={css.discountAndACWrappFirst}>
        <div className={css.freeDelyvery}>{data.freeDelivery}</div>
        <div className={css.procentSale}>{data.tenPercent}</div>
      </div>

      <div className={css.discountAndACWrappSecond}>
        <div className={css.discountForNine}>{data.fifteenPercent}</div>
        <div className={css.krohmalPackeg}>{data.starchGift}</div>
        <div className={css.smakolukForUser}>{data.communityTreats}</div>
      </div>
    </div>
  );
}
